var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 141.7 147.6",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104,66.1l-33.1,6.4l-33.1-6.4c0.4-12,10.2-21.5,22.2-21.5h22C93.8,44.6,103.6,54.1,104,66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8,4.2c9.2,0,16.6,7.4,16.6,16.6S80,37.5,70.8,37.5c-9.2,0-16.6-7.4-16.6-16.6S61.6,4.2,70.8,4.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.7,136l50.6,9.8c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0L122,136c1.1-0.2,2-1.2,2-2.3V62.7c0-0.7-0.4-1.4-0.9-1.8c-0.6-0.5-1.3-0.6-2-0.5l-14.9,2.9c-1.8-12.1-12.1-21.1-24.3-21.1h-22c-12.2,0-22.5,9-24.3,21.1l-14.9-2.9c-0.7-0.1-1.5,0-2,0.5c-0.6,0.4-0.9,1.1-0.9,1.8v70.9C17.8,134.8,18.6,135.8,19.7,136z M104.5,68.4l14.7-2.8v66l-46,8.9v-66L104.5,68.4L104.5,68.4z M59.9,46.9h22c9.9,0,18.3,7.6,19.6,17.2l-30.6,5.9l-30.6-5.9C41.5,54.5,50,46.9,59.9,46.9L59.9,46.9z M22.5,65.6l46,8.9v66l-46-8.9V65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,79.4l32.2,6.1c1.3,0.2,2.5-0.6,2.8-1.9c0.2-1.3-0.6-2.5-1.9-2.8l-32.2-6.1c-1.3-0.2-2.5,0.6-2.8,1.9C26.9,77.9,27.7,79.1,29,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1,90l-32.2-6.1c-1.3-0.2-2.5,0.6-2.8,1.9c-0.2,1.3,0.6,2.5,1.9,2.8l32.2,6.1c1.3,0.2,2.5-0.6,2.8-1.9C64.3,91.5,63.4,90.2,62.1,90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,97.8l32.2,6.1c1.3,0.2,2.5-0.6,2.8-1.9c0.2-1.3-0.6-2.5-1.9-2.8l-32.2-6.1c-1.3-0.2-2.5,0.6-2.8,1.9C26.9,96.3,27.7,97.5,29,97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,107l32.2,6.1c1.3,0.2,2.5-0.6,2.8-1.9c0.2-1.3-0.6-2.5-1.9-2.8l-32.2-6.1c-1.3-0.2-2.5,0.6-2.8,1.9C26.9,105.5,27.7,106.7,29,107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1,117.6l-32.2-6.1c-1.3-0.2-2.5,0.6-2.8,1.9c-0.2,1.3,0.6,2.5,1.9,2.8l32.2,6.1c1.3,0.2,2.5-0.6,2.8-1.9C64.3,119.1,63.4,117.9,62.1,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1,126.8l-32.2-6.1c-1.3-0.2-2.5,0.6-2.8,1.9c-0.2,1.3,0.6,2.5,1.9,2.8l32.2,6.1c1.3,0.2,2.5-0.6,2.8-1.9C64.3,128.3,63.4,127.1,62.1,126.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8,39.8c10.5,0,19-8.5,19-19c0-10.5-8.5-19-19-19s-19,8.5-19,19C51.8,31.3,60.3,39.8,70.8,39.8z M70.8,6.6C78.6,6.6,85,13,85,20.8s-6.4,14.2-14.2,14.2c-7.9,0-14.2-6.4-14.2-14.2C56.5,13,62.9,6.6,70.8,6.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon-report.2cfe6823e4afcb39fe6f2dfddb0da655.svg";
export { ForwardRef as ReactComponent };